window.ModifyCalendarMonth = function(increment, wkStartsOn, calendar) {
	var momentDate = moment([calendar.find("[data-current-year]").data("currentYear"), calendar.find("[data-current-month]").data("currentMonth")]);
	var settings = calendar.data("calendarContent").settings;
	var canModify = !settings.navigateToDataOnly;
	
	momentDate.add(increment, 'months');
	
	if (settings.navigateToDataOnly) {	
		var dates = calendar.data("calendarContent").dates;
		var navigatableDates = {};
		navigatableDates[moment().year()] = {}; // Allow navigation to the current month
		navigatableDates[moment().year()][moment().month()] = {};
		$.extend(true, navigatableDates, dates);
		
		var dataYears = Object.keys(navigatableDates);
		if (increment > 0) { // Direction of increment
			var maxYr = Math.max.apply(null, dataYears);
			var maxYrMths = Object.keys(navigatableDates[maxYr]);
			var maxMomentDate = moment([maxYr, Math.max.apply(null, maxYrMths) ]);
			
			canModify = momentDate.isSameOrBefore(maxMomentDate, 'month');
		} else if (increment < 0){
			var minYr = Math.min.apply(null, dataYears);
			var minYrMths = Object.keys(navigatableDates[minYr]);
			var minMomentDate = moment([minYr, Math.min.apply(null, minYrMths) ]);
			
			canModify = momentDate.isSameOrAfter(minMomentDate, 'month');
		}
	}
	if (canModify) {
		GenerateCalendar(momentDate, wkStartsOn, calendar);
	}
};

window.GenerateCalendar = function(momentDate, wkStartsOn, calendar) {
	var calendarContainer = calendar.find('[data-calendar-container]');
	var calendarID = calendar.data("calendarId");
	var calendarData = calendar.data("calendarContent");
	
	var calendarDates = calendarData.dates;
	var curYear = momentDate.year();
	var curMonth = momentDate.month();
	var curMonthData = {};
	if (calendarDates[curYear] && calendarDates[curYear][curMonth]) {
		curMonthData = calendarDates[curYear][curMonth];
	}

	calendar.find("[data-current-year]").text(momentDate.format("YYYY")).data("currentYear", curYear);
	calendar.find("[data-current-month]").text(momentDate.format("MMMM")).data("currentMonth", curMonth);

	var day = 1;
	var calendarHTML = '';
	var startOfMonth = momentDate.startOf('month')._d.getDay();
	while (day <= momentDate.daysInMonth()) {
		calendarHTML += '<div class="calendar-row grid-x">';
		for (var wkDay = 0; wkDay < 7; wkDay++) {		
			calendarHTML += '<div class="day blue cell auto';

			if ((((wkDay+wkStartsOn) % 7) == startOfMonth || day > 1) && day <= momentDate.daysInMonth()) {
				var isToday = moment().isSame([momentDate.year(), momentDate.month(), day], 'day');
				calendarHTML += (isToday ? ' today' : '') + '" data-calendar-day="'+day+'">' + (curMonthData[day] ? GenerateCalDay(curMonthData[day], calendarData.settings, day) : day);
				day++;
			} else {
				calendarHTML += '">';
			}
			calendarHTML += '</div>';
		}
		calendarHTML += '</div>';
	}
	calendarContainer.html(calendarHTML);
	var daysWithContent = calendarContainer.find("[data-content]").parent("[data-calendar-day]");
	daysWithContent.addClass("has-data").attr("data-toggle", "calendarPopup-"+calendarID);
	daysWithContent.on("click", function(){ViewDay(this, calendarData.settings);});
};

function GenerateCalDay(dayContent, settings, day) {
	var dotHTML = "";
	var commentIcon = '<i class="icon-talk-chat"></i>';
	var dotGenerated = [];
	var hasAtLeastOneComment = false;
	var dayHTML = "<span class='"+(settings.detailedTitle ? 'day-number-container' : '')+"'>" + day + 
		"</span><div class='day-content small-grid-x' data-content='"+_.escape(JSON.stringify(dayContent))+"'>";
	
	$(dayContent).each(function(timeblockKey, timeblock) {
		var hasComment = typeof timeblock.comments !== 'undefined' && timeblock.comments.length > 0;
		var commentHTML = "";
		hasAtLeastOneComment = hasComment | hasAtLeastOneComment;
		
		if(hasComment)  {
			commentHTML = "<button onclick=\"ShowDialog({content:'"+_.escape(_.escape(timeblock.comments))+"'}); event.stopImmediatePropagation();\" class='comments' title='"+_.escape(timeblock.comments)+"'>"+commentIcon+"</button>";
		} 
			 
		if (settings.detailedTitle) {
			dayHTML += "<div class='time-block box show-for-medium "+timeblock.cssClass+"'>";
			var showTimeEnd = (typeof timeblock.timeEnd !== 'undefined');
			if (typeof timeblock.time !== 'undefined') {
				dayHTML += "<div class='time'>" + timeblock.time + ((showTimeEnd) ? ' - ' + timeblock.timeEnd : '') + "</div>"
			}
			$(settings.titleComposition).each(function(titleKey, titleSection) {
				dayHTML += timeblock[titleSection] + " ";
			});
			dayHTML += commentHTML + "</div>";
		}

		if (dotGenerated.indexOf(timeblock.cssClass) == -1) {
			dotGenerated.push(timeblock.cssClass);
			dotHTML += " <span class='dot " + (settings.detailedTitle ? 'hide-for-medium ' : '') + timeblock.cssClass + "'></span>";
		}
	});
	if (settings.detailedTitle) {
		commentIcon = "<div class='hide-for-medium'>"+commentIcon+"</div>";
	}
	if (!hasAtLeastOneComment) {
		commentIcon = "";
	}
	dayHTML += commentIcon + dotHTML;
	dayHTML += "</div>";
	return dayHTML;
};

window.ToggleListView = function(calendar) {
	var listView = calendar.find("[data-calendar-list-view]");
	var calendarView = calendar.find("[data-calendar-header],[data-calendar]");
	var listViewBtn = calendar.find("[data-list-view]");
	
	if (listView.hasClass("hide")) {
		listView.removeClass("hide");
		calendarView.addClass("hide");
		listViewBtn.text($.i18n._(13504));
	} else {
		listView.addClass("hide");
		calendarView.removeClass("hide");
		listViewBtn.text($.i18n._(8380));
	}
};

window.ViewDay = function(day, settings) {
	var dayData = $(day).find("[data-content]").data("content");
	var calendarID = $(day).closest("[data-calendar-content]").data('calendarId');
	var reveal = $("#calendarPopup-"+calendarID);
	var timeblocksHTML = "";
	var titleHTML = "";

	$(dayData).each(function(timeKey, timeblock) {
		var showTimeEnd = (typeof timeblock.timeEnd !== 'undefined');
	
		titleHTML = timeblock.date;
		timeblocksHTML += '<div class="box '+timeblock.cssClass+'">';
		timeblocksHTML += "<div class='cell medium-auto'>" + timeblock.time + ((showTimeEnd) ? ' - ' + timeblock.timeEnd : '') + "</div>";
		$(settings.titleComposition).each(function(titleKey, titleSection) {
			timeblocksHTML += "<div class='cell medium-auto'>" + timeblock[titleSection] + "</div>";
		});
		timeblocksHTML += (typeof timeblock.comments !== 'undefined' && timeblock.comments.length > 0) ? 
				"<div class='grid-x align-middle'><div class='cell comment'>" +_.escape(timeblock.comments)+ "</div></div>" : '';
		timeblocksHTML += '</div>';
	});
	reveal.find("[data-timeblocks]").html(timeblocksHTML);
	reveal.find("[data-popup-title]").html(titleHTML);
};